var map = {
	"./astarpungar.png": 7941,
	"./bananabros.png": 8000,
	"./biscoff.jpg": 2457,
	"./cinnabon_1.jpg": 9715,
	"./donuts3.jpeg": 1644,
	"./fransk-vaffla.png": 368,
	"./grafikjustykki.png": 5389,
	"./hunangsbollur.png": 1195,
	"./kanillengja.jpeg": 108,
	"./kleinur.jpeg": 7656,
	"./kleinur.png": 9695,
	"./kokosbollur.png": 2686,
	"./kransaskeyfur.png": 2580,
	"./lakkrísdengsi.png": 2882,
	"./langijón.jpeg": 3288,
	"./mommuvinarbrauð.png": 5038,
	"./munsnudur2.jpeg": 941,
	"./múnlengja.jpeg": 7088,
	"./oreo-cookies.png": 9528,
	"./smjorkaka.jpeg": 8945,
	"./snudar.jpeg": 1729,
	"./tebollur.png": 7128,
	"./vinarbraud.jpeg": 1821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5625;